import i18next from "i18next";
import API from "../../Api/Api.js";
import { otherLanguage } from "../../utils/utils.js";
import { closeModal } from "./confirmationModal.js";
import { handleError, handleInfo } from "./notifications.js";
import qs from "qs";
const token = localStorage.getItem("token");

export const getAllShowrooms = (filter) => async (dispatch) => {
  API.defaults.headers.common["Authorization"] = token;
  const query = qs.stringify(
    {
      filters: {
        name: {
          $containsi: filter,
        },
      },
      populate: ["localizations", "adress"],
      sort: ["createdAt:desc"],
      pagination: {
        page: 1,
        pageSize: 200,
      },
    },

    {
      encodeValuesOnly: true,
    }
  );
  API.defaults.params = { locale: i18next.language };
  dispatch({ type: "SHOWROOM_LOADING" });
  try {
    let { data } = await API.get("/api/revendeurs?" + query);

    dispatch({ type: "FETCH_SHOWROOMS", payload: data.data });
  } catch (error) {
    dispatch(handleError("erreur réseau", 1));
    console.log(error);
  }
};

export const getShowroomItem = (id, noLoading) => async (dispatch) => {
  API.defaults.headers.common["Authorization"] = token;
  const query = qs.stringify(
    {
      filters: {
        id: {
          $eq: id,
        },
      },
      populate: {
        localizations: {
          populate: "*",
        },
        banner: {
          populate: "*",
        },
        photos_magasin: {
          populate: { cards: { populate: ["image", "image2"] } },
        },
        products: {
          populate: "image",
        },
        fr_products: {
          populate: "image",
        },
        events: {
          populate: "name",
        },
        adress: {
          populate: "*",
        },
        seo: {
          populate: "ogimage",
        },
      },
    },

    {
      encodeValuesOnly: true,
    }
  );
  API.defaults.params = { locale: i18next.language };
  if (!noLoading) {
    dispatch({ type: "SHOWROOM_LOADING" });
  }
  try {
    let { data } = await API.get("/api/revendeurs?" + query);

    dispatch({ type: "FETCH_SHOWROOM_ITEM", payload: data.data[0] });
  } catch (error) {
    dispatch(handleError("erreur réseau", 1));
    console.log(error);
  }
};

export const addShowroom = () => async (dispatch) => {
  API.defaults.headers.common["Authorization"] = token;
  API.defaults.params = {};
  let defaultImage = null;

  dispatch({ type: "SHOWROOM_LOADING" });
  try {
    let image = await API.get("/api/upload/files");
    defaultImage = image.data[0].id;
  } catch (error) {
    dispatch(handleError("Erreur reseau", 1));

    console.log(error);
  }

  try {
    if (!defaultImage) {
      return dispatch(
        handleError("Importer au moin une image pour procéder", 1)
      );
    }
    const defaultBanner = {
      name: "Banniére revendeur ",
      title: "banniere par default",
      subtitle: "soustitre par default",
      image: [defaultImage],
      imageMobile: [defaultImage],
    };
    const defaultBannerEng = {
      name: "Banniére revendeur ",
      title: "banniere par default (en)",
      subtitle: "soustitre par default (en)",
      image: [defaultImage],
      imageMobile: [defaultImage],
    };
    let bannerfr = await API.post("/api/sections", {
      data: defaultBanner,
      params: { locale: i18next.language },
    });
    const banneren = await API.post(
      `/api/sections/${bannerfr.data.data.id}/localizations`,
      { locale: otherLanguage(i18next.language), ...defaultBannerEng }
    );

    let defaultCard = {
      name: "carte Image magasin",
      title: "titre image magasin par défault",

      image: defaultImage,
    };

    let cardFR = await API.post("/api/cards", {
      data: defaultCard,
      params: { locale: i18next.language },
    });
    let cardEN = await API.post(
      `/api/cards/${cardFR.data.data.id}/localizations`,
      { locale: otherLanguage(i18next.language), ...defaultCard }
    );

    let defaultListFR = {
      name: "Liste d'image magasin",
      cards: [cardFR.data.data.id],
      resolution: "carré",
    };

    let defaultListEN = {
      name: "Liste d'image magasin",
      cards: [cardEN.data.id],
      resolution: "carré",
    };

    let listFR = await API.post("/api/lists", {
      data: defaultListFR,
      params: { locale: i18next.language },
    });

    let listEN = await API.post(
      `/api/lists/${listFR.data.data.id}/localizations`,
      { locale: otherLanguage(i18next.language), ...defaultListEN }
    );

    let defaultAdress = {
      fullAdress: "Numéro -- Rue --",
      postalCode: "*******",
      city: "Nice (par défaut)",
      country: "France (par défaut)",
      coordinates: [-0.370691110245275, 48.51969961538856],
    };

    let defaultShowRoom = {
      name: "Nom revendeur par défaut",
      phoneNumber: "** ** ** ** **",
      description: "Déscription revendeur par défaut",
      openTime: "Du **** au ***** de **h jusqu'a **h",
      email: "******@******.**",
      website: "www.******.com",
    };
    let defaultSEOFR = {
      title: "titre SEO article par defaut",
      description: "SEO description article par defaut",
      ogimage: defaultImage,
    };
    let defaultSEOEN = {
      title: "titre SEO article par defaut (en)",
      description: "SEO description article par defaut (en)",
      ogimage: defaultImage,
    };

    let SEOfr = await API.post("/api/seos", {
      data: defaultSEOFR,
      params: { locale: i18next.language },
    });
    const SEOen = await API.post(
      `/api/seos/${SEOfr.data.data.id}/localizations`,
      { locale: otherLanguage(i18next.language), ...defaultSEOEN }
    );

    let adressFr = await API.post("/api/adresses", {
      data: defaultAdress,
      params: { locale: i18next.language },
    });

    const adressEn = await API.post(
      `/api/adresses/${adressFr.data.data.id}/localizations`,
      { locale: otherLanguage(i18next.language), ...defaultAdress }
    );

    const revendeurFr = await API.post("/api/revendeurs", {
      data: {
        ...defaultShowRoom,
        adress: adressFr.data.data.id,
        banner: bannerfr.data.data.id,
        seo: SEOfr.data.data.id,
        photos_magasin: listFR.data.data.id,
      },
      params: { locale: i18next.language },
    });

    await API.post(
      `/api/revendeurs/${revendeurFr.data.data.id}/localizations`,
      {
        locale: otherLanguage(i18next.language),
        ...defaultShowRoom,
        seo: SEOen.data.id,
        adress: adressEn.data.id,
        banner: banneren.data.id,
        photos_magasin: listEN.data.id,
      }
    );

    dispatch(handleInfo("Revendeur Ajouté", 1));
    dispatch(getAllShowrooms());
  } catch (error) {
    dispatch(handleError("erreur réseau", 1));
    console.log(error);
  }
};

export const deleteShowRoom = (id) => async (dispatch) => {
  API.defaults.headers.common["Authorization"] = token;
  API.defaults.params = {};

  dispatch({ type: "SHOWROOM_LOADING" });
  try {
    await API.delete("/api/revendeurs/" + id);
    dispatch(handleInfo("Revendeur Supprimé", 1));
    dispatch(getAllShowrooms());
    dispatch(closeModal());
  } catch (error) {
    dispatch(handleError("erreur réseau", 1));
    console.log(error);
  }
};

export const updateShowroom =
  (id, showroom, idAdress, adress) => async (dispatch) => {
    API.defaults.headers.common["Authorization"] = token;
    const query = qs.stringify(
      {
        populate: ["localizations"],
      },

      {
        encodeValuesOnly: true,
      }
    );

    dispatch({ type: "SHOWROOM_LOADING" });
    try {
      const adressfr = await API.put(`/api/adresses/${idAdress}?${query}`, {
        data: adress,
      });
      await API.put(`/api/revendeurs/${id}`, { data: showroom });
      await API.put(
        `/api/adresses/${adressfr.data.data.attributes.localizations.data[0].id}`,
        {
          data: { coordinates: adress.coordinates },
        }
      );
      dispatch(handleInfo("Revendeur Modifié", 1));
      dispatch(getShowroomItem(id));
    } catch (error) {
      dispatch(handleError("erreur réseau", 1));
      console.log(error);
    }
  };

export const changeProductsShowed =
  (id, exposedProducts, FRproductsExposed) => async (dispatch) => {
    API.defaults.headers.common["Authorization"] = token;

    dispatch({ type: "SHOWROOM_LOADING" });
    try {
      await API.put(`/api/revendeurs/${id}`, {
        data: { products: exposedProducts, fr_products: FRproductsExposed },
      });

      dispatch(handleInfo("Revendeur Modifié", 1));
      dispatch(getShowroomItem(id));
    } catch (error) {
      dispatch(handleError("erreur réseau", 1));
      console.log(error);
    }
  };

export const changeAssociatedEvents =
  (id, associatedEvents) => async (dispatch) => {
    API.defaults.headers.common["Authorization"] = token;

    dispatch({ type: "SHOWROOM_LOADING" });
    try {
      await API.put(`/api/revendeurs/${id}`, {
        data: { events: associatedEvents },
      });

      dispatch(handleInfo("Revendeur Modifié", 1));
      dispatch(getShowroomItem(id));
    } catch (error) {
      dispatch(handleError("erreur réseau", 1));
      console.log(error);
    }
  };
